import { createFileRoute } from '@tanstack/react-router'
import PayAppDetails from '../components/pay-app-details/PayAppDetails'

export const Route = createFileRoute('/_a/payApps/$payAppId')({
  component: PayAppDetails,
})
